import { PokemonType } from "types/battle-engine/battle";
import {
  Backdrop,
  TALL_CARD_CLASS,
  cardBackground,
  Scrim,
  TiltCard,
} from "@/components/cards/card-primitives";
import { TYPE_COLORS, shade, themeFromColor } from "@/components/cards/card-theme";
import { FoilOverlay, GlareLayer } from "@/components/cards/foil/foil-layers";
import type { FoilConfig } from "@/components/cards/foil/foil-config";

/** Full-art basic energy card: glowing type orb, minimal footer. */
export const EnergyCard = ({
  type,
  foil,
}: {
  type: PokemonType;
  foil?: FoilConfig | boolean;
}) => {
  const color = TYPE_COLORS[type];
  const t = themeFromColor(color, type);

  return (
    <TiltCard>
      <div className={TALL_CARD_CLASS} style={cardBackground(t)}>
        <Backdrop t={t} />

        <div className="z-10 relative flex flex-col items-center pt-3">
          <span
            className="font-black text-[12px] text-white uppercase tracking-[0.22em]"
            style={{ textShadow: "0 2px 4px rgba(0,0,0,0.8)" }}
          >
            {type} Energy
          </span>
          <div
            className="mt-1 rounded-full w-10 h-[2px]"
            style={{ background: `linear-gradient(90deg, transparent, ${t.light}, transparent)` }}
          />
        </div>

        {/* energy orb */}
        <div className="relative flex justify-center mt-7">
          <div
            className="absolute rounded-full w-32 h-32 blur-lg -translate-y-3"
            style={{ background: `radial-gradient(circle, ${color}77 0%, transparent 70%)` }}
          />
          <div
            className="relative flex justify-center items-center rounded-full w-[104px] h-[104px]"
            style={{
              background: `radial-gradient(circle at 35% 30%, ${shade(color, 0.55)}, ${color} 55%, ${shade(color, -0.5)})`,
              boxShadow: `0 0 26px ${color}99, inset 0 -8px 14px rgba(0,0,0,0.45), inset 0 8px 12px rgba(255,255,255,0.4)`,
              border: "2px solid rgba(0,0,0,0.5)",
            }}
          >
            <img
              src={`/assets/pokemon-types/${type.toLowerCase()}.svg`}
              alt={type}
              className="w-14 h-14 drop-shadow-[0_3px_3px_rgba(0,0,0,0.5)]"
            />
          </div>
        </div>

        <Scrim>
          <div className="flex justify-between items-center">
            <span className="font-bold text-[8px] text-white/80 tracking-[0.2em]">BASIC</span>
            <span className="font-bold text-[8px] tracking-[0.15em]" style={{ color: t.light }}>
              +1 {type}
            </span>
          </div>
        </Scrim>

        <FoilOverlay foil={foil} seed={type} />
        <GlareLayer />
      </div>
    </TiltCard>
  );
};
